import React from 'react';
import TaskPlanner from './components/taskPlanner';
import Layout from '@/common/Layout';

const Tasks = ({ taskStatus }) => {
  return (
    <Layout sider={false}>
      <TaskPlanner taskStatus={taskStatus} />
    </Layout>
  );
};

export default Tasks;
